module.exports = __webpack_public_path__ + "static/img/software-development.e010b54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/software-development.png
// module id = BCC1
// module chunks = 0